import Vue, { CreateElement } from '@src/vue'
import { Component } from 'vue-property-decorator'
import { snakecaseKeys } from '@src/util/functions'
import Checkup from '@src/data/checkup'
import { API } from '@src/lib/api_path'
import ApiClient from '@src/lib/api_client'
import { H5 } from '@src/elements/typography/typography'

@Component({
  computed: {
    checkup () {
      return this.$store.state.checkup
    }
  }
})
export default class CompletedOnboarding extends Vue {

  checkup: Checkup
  private apiClient: ApiClient

  constructor () {
    super()
    this.apiClient = new ApiClient()
  }

  created () {
    return this.completeCheckup()
  }

  completeCheckup () {
    let onboarding = new Checkup(this.checkup)

    if (onboarding.isComplete()) {
      // user completed the onboarding by following all steps
      return this.completeInitialCheckup(this.$route.params.id, onboarding)
    }

    // force complete the onboarding
    onboarding.forceComplete()
    this.apiClient.put(`${API.TRAINERS_API.CHECKUPS.replace('{memberId}', this.$route.params.id)}/${onboarding.id}`, { checkup: snakecaseKeys(onboarding) })
      .then(() => this.completeInitialCheckup(this.$route.params.id, onboarding))
      .catch(err => console.error('Failed to update checkup, ', err))
  }

  completeInitialCheckup (memberId, checkup: Checkup) {
    // having performed the initial checkup means the user registration is complete
    const member = {
      initialCheckupId: checkup.id,
      registeredAt: new Date().toISOString()
    }
    return this.apiClient.put(`${API.TRAINERS_API.MEMBERS}/${memberId}`, { member: snakecaseKeys(member) })
  }

  render (h: CreateElement) {

    return <div class='onboarding-completed'>
      <H5>{this.$t('PAGE.MEMBERS.ONBOARDING.COMPLETED')}</H5>
    </div>
  }
}
